import type { SchoolSubscription } from '@/types/subscription_schema';

export function normalizeSubscription(subscription: SchoolSubscription): SchoolSubscription {
  const type = subscription.subscription_type;
  return {
    ...subscription,
    plan: subscription.subscription_plan || subscription.plan,
    planId: subscription.subscription_plan_id || subscription.planId,
    is_trial: type ? type === 'promo_trial' : subscription.is_trial,
    trial_ends_at: subscription.promo_trial_ends_at || subscription.trial_ends_at,
  };
}

// Presentation only: feature access remains enforced by the server.
export function subscriptionDisplay(
  subscription: Partial<SchoolSubscription> | null | undefined,
  loading = false,
  failed = false,
  now = Date.now(),
) {
  const sub = subscription;
  const name = sub?.subscription_plan?.name || sub?.plan?.name;
  const type = sub?.subscription_type;
  const trial = type ? type === 'promo_trial' : !!sub?.is_trial;
  const promo = type ? type === 'promo' : sub?.payment_method === 'promo';
  const trialEndsAt = sub?.promo_trial_ends_at || sub?.trial_ends_at;
  const end = trial ? trialEndsAt || sub?.end_date : sub?.end_date;
  const expired = sub?.status === 'expired' || (!!end && Date.parse(end) <= now);
  const inactive = sub?.status === 'inactive' || sub?.status === 'cancelled';
  const paid = sub?.status === 'active' && !expired && !trial && !promo &&
    (type === 'paid' || (!type && sub?.payment_status === 'paid'));

  let badge = 'Unavailable';
  if (loading) badge = 'Loading...';
  else if (failed) badge = 'Unavailable';
  else if (expired) badge = 'Expired';
  else if (sub?.status === 'cancelled') badge = 'Cancelled';
  else if (sub?.status === 'pending_payment') badge = 'Payment pending';
  else if (inactive) badge = name ? 'Inactive' : 'Free';
  else if (trial) badge = 'Trial';
  else if (promo) badge = 'Promo';
  else if (paid) badge = 'Active';

  return {
    name: loading ? 'Loading...' : name || (badge === 'Free' ? 'Free' : 'Subscription'),
    badge,
    trial: !failed && !loading && trial,
    trialEndsAt,
    freeOrInactive: !failed && !loading && (inactive || expired),
  };
}
